import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {WebinarHeroComponent} from '../../components/webinar-hero/webinar-hero.component';
import {
    WebinarTargetGroupComponent,
    WebinarTargetGroupLevel,
} from '../../components/webinar-target-group/webinar-target-group.component';
import {
    WebinarInstructor,
    WebinarInstructorSectionComponent,
} from '../../components/webinar-instructor-section/webinar-instructor-section.component';
import {WEBINAR_INSTRUCTOR_ANDREAS_SCHLIEFER} from '../../webinar-instructors';
import {WebinarAgendaComponent, WebinarContent} from '../../components/webinar-agenda/webinar-agenda.component';
import {getParameterByName} from '../../../../shared/lib/get-parameters-by-name';
import {FormsModule} from '@angular/forms';
import {WebinarSignupSectionComponent} from '../../components/webinar-signup-section/webinar-signup-section.component';
import {isPlatformBrowser} from '@angular/common';
import {ExpertWebinarFaqs} from "../../components/expert-webinar-faq/expert-webinar-faqs.component";

@Component({
    selector: 'neuerungen-in-ax-schliefer',
    standalone: true,
    imports: [
        FormsModule,
        WebinarHeroComponent,
        WebinarAgendaComponent,
        WebinarTargetGroupComponent,
        WebinarHeroComponent,
        WebinarAgendaComponent,
        WebinarTargetGroupComponent,
        WebinarInstructorSectionComponent,
        WebinarSignupSectionComponent,
        ExpertWebinarFaqs,
    ],
    templateUrl: './neuerungen-in-autoixpert-schliefer.component.html',
    styleUrl: '../fachwebinare.scss',
})
export class NeuerungenInAutoixpertSchlieferComponent implements OnInit {
    protected readonly titleService = inject(Title);
    protected readonly metaService = inject(Meta);
    protected readonly httpClient = inject(HttpClient);
    protected readonly platformId = inject(PLATFORM_ID);

    protected webinarDate: string | null = null;
    protected webinarTitle = 'Neuerungen in autoiXpert';
    protected webinarTitleShort = 'Neuerungen in aX';
    protected targetGroupLevel: WebinarTargetGroupLevel = {
        beginner: true,
        intermediate: true,
        professional: true,
    };
    protected instructors: Array<WebinarInstructor> = [WEBINAR_INSTRUCTOR_ANDREAS_SCHLIEFER];
    protected price: number = 0;
    protected duration = 2;
    protected maximumNumberOfParticipants = null; // 100;
    protected eventOverbooked = false;
    protected webinarContents: Array<WebinarContent> = [
        {
            title: 'Online-Kundenunterschrift',
            description: '',
            link: 'https://wissen.autoixpert.de/hc/de/articles/19728164462738-Unterschrift-vom-Kunden-online-einholen',
        },
        {
            title: 'Korrekturen Wiederbeschaffungswert',
            description: '',
            link: 'https://wissen.autoixpert.de/hc/de/articles/19887584643730-Abz%C3%BCge-Aufwertungen-beim-Wiederbeschaffungswert',
        },
        {
            title: 'Minderwertberechnung mit Netto-Werten',
            description: '',
            link: 'https://wissen.autoixpert.de/hc/de/articles/20091365279122-Wertminderung-mit-ohne-Vorsteuerabzug-Unternehmer-Privatleute',
        },
        {
            title: 'Seiten zählen',
            description: '',
            link: 'https://wissen.autoixpert.de/hc/de/articles/18698552383890-Seiten-des-Gutachtens-automatisch-z%C3%A4hlen',
        },
        {
            title: 'Neue Textbausteinbedingungen',
            description: '',
            link: 'https://wissen.autoixpert.de/hc/de/articles/360005057131-Textbausteine-anpassen',
        },
        {
            title: 'E-Bike und Fahrradgutachten',
            description: '',
            link: 'https://wissen.autoixpert.de/hc/de/articles/18090612593810-Fahrrad-Gutachten-erstellen',
        },
        {
            title: 'Honorartabelle unterschreiben',
            description: '',
            link: 'https://wissen.autoixpert.de/hc/de/articles/17161739271954-Honorartabelle-mit-Auftrag-Abtretung-unterschreiben-lassen',
        },
        {
            title: 'Gesamtpreisrechner',
            description: '',
            link: 'https://www.autoixpert.de/Gesamtkostenrechner',
        },
        {
            title: 'GTÜ-Rechnungsimport',
            description: '',
            link: 'https://wissen.autoixpert.de/hc/de/articles/19896767062418-GT%C3%9C-Rechnungen-importieren-EGUB-GT%C3%9C',
        },
        {
            title: '...und vieles mehr',
            description: 'Weitere neue Features zeigen wir je nach Bedarf.',
            link: '',
        },
    ];

    constructor() {
        this.titleService.setTitle(`${this.webinarTitleShort} | Kostenfreies Online-Webinar`);
        this.metaService.addTag({
            name: 'description',
            content: `Fachwebinar ${this.webinarTitle} Wissen für Kfz-Sachverständige - rund um autoiXpert`,
        });
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.webinarDate = atob(getParameterByName('webinarDate') ?? '');
        }
    }
}
